import axios from "axios";
import { baseUrl } from "./baseUrl";

export const baseGetRequest = async (url) =>
  axios.get(
    `${baseUrl}/${url}?api_key=0bdaffe7e2eab547e56a8fb25f90ff20&language=en-US`
  );
